export default __webpack_public_path__ + "static/media/deepdao_minimalistic_logo.4a93604e.svg";